import * as React from 'react';
import { ContextService } from '../services/context_service';
import { lazyInject } from '../services/inversify';

export interface WComponentProps extends React.ClassAttributes<any> {
    persistenceKey?: string;
}
export interface WComponentState {
    dummy?: string;
}
/*
export interface WComponentIf {
    onMount?(): void;
    onUnmount?(): void;
}
*/
export class WComponent <T extends WComponentProps, S extends WComponentState> // abstract
    extends React.Component<T, S>  { // implements WComponentIf

    @lazyInject(ContextService) public contextService: ContextService;

    constructor(props: any) {
        super(props);
        if (this.props.persistenceKey) {
            console.log('Lade State für ' + this.props.persistenceKey);
            this.state = this.contextService.get(this.props.persistenceKey);
            console.log('State geladen für ' + this.props.persistenceKey, this.state);
        }
        this.contextService.set('tooltipOnOff', 'on');
    }
    onUnmount() {}
    componentWillUnmount() {
        if (this.props.persistenceKey) {
            console.log('Speichere State für ' + this.props.persistenceKey);
            this.contextService.set(this.props.persistenceKey, this.state);  // Speichern
        }
        this.onUnmount();
    }
}
